<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <v-row class="mt-10">
      <v-col class="d-flex flex-1 align-center justify-space-between">
        <span class="header bold text-tcdc-green">{{form.branch ? form.branch.branch_name : ''}}</span>
        <GreenLabel name="what's on" @onPress="toEvent" />
      </v-col>
    </v-row>
    <v-row v-if="form.video_url">
      <v-col>
        <youtube :video-id="videoId"
                 ref="youtube"
                 :player-vars="playerVars"
                 width="100%"
                 height="500px">
        </youtube>
      </v-col>
    </v-row>
    <template v-else>
      <v-row v-if="form.slide_images && form.slide_images.length > 0" class="mb-3">
        <v-col>
          <ImageCarousel :images="form.slide_images"/>
        </v-col>
      </v-row>
      <v-row v-if="form.slide_images && form.slide_images.length > 0">
        <GreenButton class="ml-3 mb-3" label="Download as zip" @onPress="openLink(form.download_zip)"></GreenButton>
      </v-row>
    </template>
    <v-row>
      <v-col>
        <div class="vhtml" v-html="form[`description_${lang}`]"></div>
      </v-col>
    </v-row>
    <v-row v-if="!visibleFull && form && form.full_profile" class="mb-3">
      <v-col cols="8" md="5" lg="4">
        <GreenButton label="see full profile" @onPress="fullHandler" />
      </v-col>
    </v-row>
    <v-row v-if="visibleFull" class="mb-3">
      <v-col>
        <div class="vhtml" v-html="form[`full_profile_${lang}`]"></div>
      </v-col>
    </v-row>
    <template v-if="form.video_url">
      <v-row v-if="form.slide_images && form.slide_images.length > 0" class="mb-3">
        <v-col>
          <ImageCarousel :images="form.slide_images" />
        </v-col>
      </v-row>
      <v-row v-if="form.slide_images && form.slide_images.length > 0">
        <GreenButton class="ml-3 mb-3" label="Download as zip" @onPress="openLink(form.download_zip)"></GreenButton>
      </v-row>
    </template>
    <!-- <v-row>
      <v-col>
        <span class="text-tcdc-green"
          >Lorem Ipsum is simply dummy text of the printing and typesetting
          industry</span
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span class="sub-header1">What is Lorem Ipsum?</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span
          >Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book. It has survived not only
          five centuries, but also the leap into electronic typesetting,
          remaining essentially unchanged. It was popularised in the 1960s with
          the release of Letraset sheets containing Lorem Ipsum passages, and
          more recently with desktop publishing software like Aldus PageMaker
          including versions of Lorem Ipsum.</span
        >
      </v-col>
    </v-row>-->
  </div>
</template>

<script>
import ImageCarousel from "../../../components/carousels/ImageCarousel";
import GreenLabel from "../../../components/labels/GreenLabel";
import GreenButton from "../../../components/buttons/GreenButton";
import {mapState} from "vuex";
import { getIdFromUrl } from 'vue-youtube';
import Loading from 'vue-loading-overlay';

export default {
  components: {
    ImageCarousel,
    GreenLabel,
    GreenButton,
    Loading
  },
  // async created() {
  //   if (this.form.video_url) {
  //     await this.getIdFromYoutube(this.form.video_url);
  //   }
  // },
  async mounted() {
    if (this.form.video_url) {
      await this.getIdFromYoutube(this.form.video_url);
    }
  },
  methods: {
    openLink(url) {
      if (url) {
        window.open(url);
      }
    },
    async toEvent() {
      this.isLoading = true;
      await this.$store.dispatch("Branch/getBranchById", this.form.branch_id);
      this.isLoading = false;
      this.$router.push('/home');
    },
    fullHandler() {
      this.visibleFull = true;
    },
    getIdFromYoutube(url){
      this.videoId = getIdFromUrl(url);
    },
  },
  watch: {
    routePath: function () {
      if (this.$route.hash) {
        this.$router.go();
      }
    },
    branchName: async function () {
      console.log(this.form)
      if (this.form.video_url) {
        await this.getIdFromYoutube(this.form.video_url);
        // this.$forceUpdate();
      }
    }
  },
  computed:{
    ...mapState({
      form : state=>{
        return state.About.form;
      },
      lang: state => state.Branch.lang,
      branchName: state => state.Branch.branch_name
    }),
    routePath: function () {
      return this.$route.path;
    }
  },
  data: () => ({
    videoId: 'jXyhD4ZLbQA',
    isLoading: false,
    playerVars: {
      autoplay: 1
    },
    visibleFull: false,
    seeBigger: false,
  })
};
</script>

<style></style>
